import API from './api';
import credentialsStore from './credentialsStore';

const refreshTokenWhenNeeded = async () => {
  if (API.tokenRefreshPromise) return API.tokenRefreshPromise;
  if (!API.access_token || !API.refresh_token) {
    return;
  }

  const parsedPayload = credentialsStore.parseJwtPayload(API.access_token);
  const now = Math.floor(new Date().getTime() / 1000);
  const exp = parseInt(parsedPayload.exp);

  if (exp > now) return;

  const previousAccessToken = API.access_token;
  const sessionVersion = API.sessionVersion;
  API.tokenRefreshPromise = (async () => {
    try {
      const res = await API.refreshSession(API.refresh_token);
      if (API.sessionVersion !== sessionVersion) throw new Error('Session changed during authentication.');
      // Need to see if user was impersonating, because we need to impersonate again
      if (API.isImpersonating) {
        await API.impersonateUser(API.userId, res.accessToken).then(user => {
          // Update AccessToken on header Authorization
          API.setAccessToken(user.token.accessToken);
        });
      }
    } catch (error) {
      if (API.sessionVersion === sessionVersion) API.setAccessToken(previousAccessToken);
      throw error;
    } finally {
      if (API.sessionVersion === sessionVersion) API.tokenRefreshPromise = null;
    }
  })();
  return API.tokenRefreshPromise;
};

// Update only accessToken (used when impersonating)
const setAccessToken = newToken => {
  API.access_token = newToken;
  API.headers.Authorization = `Bearer ${newToken}`;
};

// Update the accessToken and refreshToken (used by login and refresh session)
const setTokens = ({ accessToken, refreshToken }) => {
  API.refresh_token = refreshToken;
  API.setAccessToken(accessToken);
};

export default { refreshTokenWhenNeeded, setAccessToken, setTokens };
